const hasNativeShareSupport = () => {
    return typeof navigator.share !== 'undefined' && navigator.share;
};

const triggerNativeShareDialog = async (shareTitle, shareUrl) => {
    try {
        await navigator.share({
            title: shareTitle,
            url: shareUrl,
        });

        return true;
    } catch (e) {
        console.error('Native share dialog failed to trigger: ', e);
        return false;
    }
};

export { hasNativeShareSupport, triggerNativeShareDialog };
